// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@steiner/Overrides/Components/ProductSelector";
import { addToCartButtonStyles } from "@steiner/XDL/PreStyle/button";
import { color, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.selectButton = {
    ...mergeWithCss(addToCartButtonStyles, {
        css: css`
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    }),
};

productSelectorStyles.actionsGridItem = {
    width: 12,
};

productSelectorStyles.clearIcon = {
    css: css`
        position: absolute;
        right: 40px;
        top: 35px;
        cursor: pointer;
        transition: transform 0.2s ease-in-out;

        &,
        & svg {
            width: 16px;
            height: 16px;
        }

        &:not(:disabled):hover {
            color: ${color("danger")};
        }
    `,
};
